//Reset data
export const RESET = "TICKET_LIST_RESET"

//Loading
export const SET_TOGGLE_LOADING = "TICKET_LIST_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "TICKET_LIST_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "TICKET_LIST_SET_HIDE_LOADING"

//Pagination

export const SET_PAGINATION ="TICKET_LIST_SET_PAGINATION"

//Message
export const SET_MESSAGE = "TICKET_LIST_SET_MESSAGE"
export const SET_IS_SUCCESS = "TICKET_LIST_SET_IS_SUCCESS"
export const SET_IS_ERROR = "TICKET_LIST_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "TICKET_LIST_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "TICKET_LIST_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "TICKET_LIST_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "TICKET_LIST_SET_ITEMS"
export const SET_APPEND_ITEMS = "TICKET_LIST_SET_APPEND_ITEMS"
export const SET_CURRENT_ITEM = "TICKET_LIST_SET_CURRENT_ITEM"
//Options & Raisons
export const SET_RAISONS = "TICKET_LIST_SET_RAISONS"
export const SET_OPTIONS = "TICKET_LIST_SET_OPTIONS"

